/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2020
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([],() => {
	class DateTimeHelper {
		//Get date in format of YYYY-MM-DDTHH:mm:ss.
		//All input formats valid for jQuery.format.date eg: 2020-08-12T16:22:33.527-07:00 (JAXB) or Sat Aug 22 2020 16:22:33 GMT-0700 (PDT) (Unix Timestamp)
		// the regex will remove everything after '.'
		static getISOString(date) {
			return date.toISOString().replace(/\..*/, '');
		}
	}

	return DateTimeHelper;
});
